export default "/images/folder.svg?2ebe259cc3c45ce62959d46e3306dc22";